module.exports = __webpack_public_path__ + "static/colgadas-020.thumb-706782d01e3c4c763178e57aa89f72c8.jpg";